export const statusMap = {
  counting: 'Quote Pending',
  count_pending: 'Quote Pending',
  count_succeeded: 'Quoted',
  count_failed: 'Quote Error',
  generating: 'Pending',
  generate_succeeded: 'Ready/Available',
  generate_failed: 'System Error',
  downloading: 'Downloading',
  download_succeeded: 'Downloaded',
  download_failed: 'System Error',
  charging: 'Charge Pending',
  charge_succeeded: 'Card Charged/Ready',
  charge_failed: 'Credit Card Error',
  notifying: 'Ready/Notifying',
  notify_succeeded: 'Ready For Download',
  notify_failed: 'Ready/Notification Error',
};

export const validStatusesToOpenOptionsMenu = {
  download_succeeded: true,
  download_failed: true,
  charge_succeeded: true,
  charge_failed: true,
  notify_succeeded: true,
  notify_failed: true,
};

export const validStatusesForDownload = {
  generate_succeeded: true,
  download_succeeded: true,
  download_failed: true,
  charge_succeeded: true,
  notifying: true,
  notify_succeeded: true,
  notify_failed: true,
};

export const receiptStatuses = [
  'download_succeeded',
  'downloading',
  'download_failed',
  'charge_succeeded',
  'notifying',
  'notified',
  'notify_failed',
  'notify_succeeded',
];

export const mapExportTypes = (key) => {
  const mappableKey = key.replace('flight_status_by_', '');
  const map = {
    deparr: 'By Departures or Arrivals',
    route: 'By Route',
    arrivals: 'By Arrivals',
    departures: 'By Departures',
  };
  return map[mappableKey] ? map[mappableKey] : '';
};

export const mapCategories = (key) => {
  const mappableKey = key
    .replace('deparr', '')
    .replace('route', '')
    .replace('arrivals', '')
    .replace('departures', '');
  const map = {
    flight_status_by_: 'Historical Flight Status',
    schedules_by_: 'Schedules',
  };
  return map[mappableKey] ? map[mappableKey] : '';
};

export const validStatuesForDownload = {
  generate_succeeded: true,
  download_succeeded: true,
  download_failed: true,
  charge_succeeded: true,
  notifying: true,
  notify_succeeded: true,
  notify_failed: true,
};



// WEBPACK FOOTER //
// ./modules/DataExports/components/home/constants.js